export default __webpack_public_path__ + "src/public/FrameImage.jpg";